module.exports = __webpack_public_path__ + "img/xqimg8.b93950eb.png";